/**
 * 页眉台头压缩：与 PrintTemplateEditor 滑块、PrintPreview 预览/打印一致。
 * 段距/标题留白允许略负，以进一步压紧行盒（margin 可为负）。
 */
export function clampHeaderLayoutFromPage(page) {
  const p = page || {}
  const lhRaw = Number(p.headerContentLineHeight ?? 1.22)
  const lh =
    Number.isFinite(lhRaw) && lhRaw > 0
      ? Math.min(2.4, Math.max(0.78, lhRaw))
      : 1.22
  const fs = Math.min(16, Math.max(7, Number(p.headerRootFontSizePx ?? 11) || 11))
  const gapEm = Math.min(0.55, Math.max(-0.14, Number(p.headerParagraphGapEm ?? 0.08) || 0))
  const hmEm = Math.min(0.55, Math.max(-0.12, Number(p.headerRichHeadingMarginEm ?? 0.12) || 0))
  const imgPx = Math.min(160, Math.max(12, Number(p.headerInlineImageMaxHeightPx ?? 48) || 48))
  const zoom = Math.min(1, Math.max(0.65, Number(p.headerBlockZoom ?? 1) || 1))
  return {
    lh,
    lhCss: String(lh),
    fs,
    gapEm,
    hmEm,
    imgPx,
    zoom
  }
}
